import { Component, Input } from '@angular/core';
import { MunilyTooltipPosition } from './tooltip.types';

@Component({
  selector: 'common-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() text: string = '';
  @Input() position: MunilyTooltipPosition = 'above';
  @Input() disabled: boolean = false;
  @Input() icon: string = 'info';
  /**
   * Modificador extra para el panel del overlay (p. ej.
   * `munily-tooltip-panel--wide` para textos largos como fórmulas). Se suma a
   * la clase base, nunca la reemplaza.
   */
  @Input() panelClass: string = '';

  get panelClasses(): string {
    return this.panelClass
      ? `munily-tooltip-panel ${this.panelClass}`
      : 'munily-tooltip-panel';
  }
}
